import createPage from '../create-page'
import LightboxCollectionPage from './lightbox-collection-page'

export default createPage(LightboxCollectionPage, 'LIGHTBOX_COLLECTION', true)



// WEBPACK FOOTER //
// ./src/components/lightbox-collection-page/index.js